import { DefaultRole, DefaultRoleDto } from 'app/area/administration/shared/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

export const mapFromDefaultRole = (defaultRoleDto: DefaultRoleDto): DefaultRole => ({
  value: defaultRoleDto.v,
  ...(isDefinedIncludingZero(defaultRoleDto.d) && { description: defaultRoleDto.d }),
  ...(isDefinedIncludingZero(defaultRoleDto.ld) && { longDescription: defaultRoleDto.ld }),
  ...(isDefinedIncludingZero(defaultRoleDto.disabled) && { disabled: defaultRoleDto.disabled })
});

export const mapToDefaultRole = (defaultRole: DefaultRole): DefaultRoleDto => ({
  v: defaultRole.value,
  ...(isDefinedIncludingZero(defaultRole.description) && { d: defaultRole.description }),
  ...(isDefinedIncludingZero(defaultRole.longDescription) && { ld: defaultRole.longDescription }),
  ...(isDefinedIncludingZero(defaultRole.disabled) && { disabled: defaultRole.disabled })
});
